import { useSelector } from 'react-redux';
import { isCurrentPlanSelector } from '../../../PlanSelectionNewWhatIfs/PlanSelectionNewWhatIfsSelector';
import { useRouteParams } from './useRouteParams';

interface UseIsCurrentPlanSelected {
  isCurrentPlanSelected: boolean;
}

export const useIsCurrentPlanSelected = (): UseIsCurrentPlanSelected => {
  const { clientId } = useRouteParams();

  return {
    isCurrentPlanSelected: useSelector(state => isCurrentPlanSelector(state, { clientId })),
  };
};
